module.exports = __webpack_public_path__ + "img/logo-dpi-white.71d09901.png";